<template>
    <drawer v-if="hasDAM" title="Select Content Hub Image">
        <div class="contenthub-drawer">
            <iframe
                id="chIframe"
                frameborder="0"
                scrolling="auto"
                :src="mappUrl"
                style="width: 100%; height:85vh;"
            />
        </div>
    </drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Drawer from '@/components/shared/drawer/drawer';
import { SET_CH_TOKEN, SET_SELECTED_MEDIA, HIDE_DRAWER } from '@/store/types/mutation-types';

export default {
    components: { Drawer },

    data() {
        return {
            images: [],
            selectedItems: {},
            selectedItem: null,
            selectedForPublic: null,
            publicImages: [],
            searchTerm: '',
            username: '',
            password: '',
            currentPage: 1,
            pageSize: 12,
            totalResults: 0,
        };
    },

    computed: {
        ...mapState({
            chToken: state => state.user.chToken,
        }),

        hasDAM() {
            return process.env.VUE_APP_CH && process.env.VUE_APP_CH !== '#{ch_server}#';
        },

        mappUrl() {
            return `${ process.env.VUE_APP_CM_URL }/sitecore/shell/client/Applications/FlexMApp`;
        },
    },

    created() {
        window.dialogClose = this.dialogClose;
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
            setToken: SET_CH_TOKEN,
            setSelectedMedia: SET_SELECTED_MEDIA,
        }),

        dialogClose() {
            this.applyImage();
        },

        applyImage() {
            if (!window.returnValue) return;

            const mappObject = JSON.parse(window.returnValue);
            const item = {
                id: '{00000000-0000-0000-0000-000000000000}',
                name: mappObject.alternative || '',
                mediaType: 'image',
                url: mappObject.source,
                altText: mappObject.alternative || '',
                extension: '',
                height: '',
                width: '',
                chid: mappObject.id,
            };

            this.setSelectedMedia(item);
            this.hideDrawer();
        },
    },
};
</script>

<style lang="scss" scoped>
.contenthub-drawer {
    padding: 40px;
    min-height: 650px;

    &__label {
        font-weight: 700;
        margin-bottom: 15px;
    }

    &__paging {
        display: flex;
    }

    &__paging-number {
        cursor: pointer;
        margin-right: 5px;
    }

    &__paging-number--selected {
        text-decoration: underline;
    }

    &__row {
        min-width: 600px;
    }

    &__login-form {
        max-width: 400px;
        margin-top: 10px;
    }

    &__footer {
         position: fixed;
        bottom: 0;
        left: 0;
        right: 0;

        display: flex;
        padding: 0;
        margin: 0;
    }

    &__login {
        color: var(--form-buttonColor);
        background-color: var(--form-buttonBackgroundColor);
        padding: 10px 30px;
        border-radius: 4px;
        font-weight: 700;
        font-size: 14px;
        margin-right: 10px;

        &:hover {
            color: var(--form-buttonHoveColor);
            background-color: var(--form-buttonHoverBackgroundColor);
        }
    }

    &__button {
        flex-grow: 1;
        z-index: 2; // issue with z-index for toggles going over button
        min-height: 50px;
        &--continue {
            @extend %button;
        }

        &--cancel {
            @extend %button-alt;
        }

    }
}
</style>
